import { useCallback } from 'react';
import { platformAnalyticsV2 } from '../../../utils/analytics/index.es.js';
import { InteractionSource, CtaType } from '../../../utils/analytics/PlatformAnalyticsV2Service.generated.es.js';
import { useNavBarContext } from '../../../contexts/NavBarProvider/NavBarContext.es.js';
import { EventIds } from '../../../enums/EventIds.es.js';

var NavbarInteractionSource = InteractionSource.Navbar;
var NavbarCtaType = CtaType.Button;
var useLinkAnalyticsV2Handler = function useLinkAnalyticsV2Handler() {
  var _useNavBarContext = useNavBarContext(),
    config = _useNavBarContext.config;
  var handleSendAnalyticsV2 = useCallback(function (ctaGoal, ctaText, ctaDestination) {
    var interactionSource = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : NavbarInteractionSource;
    var ctaType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : NavbarCtaType;
    return function () {
      try {
        platformAnalyticsV2.trackCTAClicked({
          ctaGoal: ctaGoal,
          ctaType: ctaType,
          interactionSource: interactionSource,
          ctaText: ctaText,
          ctaDestination: ctaDestination
        });
      } catch (error) {
        var _config$log;
        config === null || config === void 0 ? void 0 : (_config$log = config.log) === null || _config$log === void 0 ? void 0 : _config$log.error("\"".concat(ctaGoal, "\" Analytics send error"), EventIds.AnalyticsSendError, error);
      }
    };
  }, [config === null || config === void 0 ? void 0 : config.log]);
  return handleSendAnalyticsV2;
};

export { NavbarCtaType, NavbarInteractionSource, useLinkAnalyticsV2Handler };
